import { createInertiaApp, Head, Link, router } from '@inertiajs/vue3'
import mitt from 'mitt'
import { createApp, h } from 'vue'
import '../css/app.css'

window.mitt = window.mitt || new mitt()

import { useCartStore } from '@/stores/cartStore.js'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueScrollTo from 'vue-scrollto'
// import Counter from '@/Blocks/Counter.vue'; Black Friday
// import { i18nVue } from 'laravel-vue-i18n';

// import { createI18n } from 'vue-i18n';
// const i18n = createI18n({
//     // something vue-i18n options here ...
//     fallbackLocale: 'nl',
//     messages: {
//         es: await import(`../lang/${locale}.json`),
//         nl: await import(`../lang/nl.json`),
//     },
// });

// import * as Sentry from '@sentry/vue';
import { browserTracingIntegration, init } from '@sentry/vue'
import WizardIntro from '@/Blocks/Aside/Wizard.vue'
import Date from '@/Blocks/Date.vue'
import Breadcrumbs from '@/Components/Breadcrumbs.vue'
import CardLink from '@/Components/CardLink.vue'
import Checkbox from '@/Components/Checkbox.vue'
import KeyQty from '@/Components/Configuration/KeyQty.vue'
import UploadFile from '@/Components/Configuration/UploadFile.vue'
import InfoModal from '@/Components/InfoModal.vue'
import ModalComponent from '@/Components/Modal.vue'
import ReviewStars from '@/Components/ReviewStars.vue'
import Validation from '@/Components/Validation.vue'
import VuePicture from '@/Components/VuePicture.vue'
import Layout from '@/Layouts/AppLayout.vue'
import Card from '@/Layouts/Card.vue'
import { LazyHydrationWrapper } from 'vue3-lazy-hydration'
// Axios
import axios from 'axios'
window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.withCredentials = true

// Fonts
import './fonts'
// HeadlessUI
import {
   Dialog,
   DialogOverlay,
   DialogTitle,
   Listbox,
   ListboxButton,
   ListboxLabel,
   ListboxOption,
   ListboxOptions,
   Menu,
   MenuButton,
   MenuItem,
   MenuItems,
   Popover,
   PopoverButton,
   PopoverPanel,
   RadioGroup,
   RadioGroupDescription,
   RadioGroupLabel,
   RadioGroupOption,
   TransitionChild,
   TransitionRoot,
} from '@headlessui/vue'

import useErrorLogging from '@/Composables/useErrorLogging'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createPinia } from 'pinia'
import { useAppStore } from './stores/appStore'
const { logError } = useErrorLogging()

createInertiaApp({
   progress: {
      color: '#369fff',
   },
   // resolve: async (name) => {
   //    try {
   //       const component = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'), {
   //          eager: true,
   //       })

   //       component.default.layout = component.default.layout || Layout
   //       return component
   //    } catch (error) {
   //       logError(error, name)
   //       throw error
   //    }
   // },

   // Temporary fix for legacy catalog pages
   resolve: async (name) => {
      try {
         // First try the original path
         const component = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'), {
            eager: true,
         })

         component.default.layout = component.default.layout || Layout
         return component
      } catch (error) {
         // If the original path fails, try the alternative path
         try {
            const alternativeName = name.replace('CatalogLegacy', 'Catalog')
            const component = await resolvePageComponent(`./Pages/${alternativeName}.vue`, import.meta.glob('./Pages/**/*.vue'), {
               eager: true,
            })

            component.default.layout = component.default.layout || Layout
            return component
         } catch (alternativeError) {
            logError(error, name)
            throw error
         }
      }
   },
   setup({ el, App, props, plugin }) {
      const app = createApp({ render: () => h(App, props) })
      const pinia = createPinia()

      if (env === 'staging' || env === 'production') {
         init({
            app,
            dsn: 'https://36f0b2806338f7f3d1d2b5762ad008d6@o4508851611828224.ingest.de.sentry.io/4508851614187600',
            integrations: [browserTracingIntegration()],
            ignoreErrors: ["Can't find variable: gmo"],
            beforeSend(event) {
               if (event.exception && event.exception.values && event.exception.values[0]) {
                  if (event.exception.values[0].value.includes('Importing a module script failed.')) {
                     return null // Ignore this error
                  }
                  if (event.exception.values[0].value.includes('Network Error')) {
                     return null // Ignore this error
                  }
                  if (event.exception.values[0].value.includes('Object.prototype.hasOwnProperty.call')) {
                     return null // Ignore this error
                  }
               }
               return event // Send all other errors
            },
            environment: env,
         })
      }

      // // Handle console errors
      // if (env === 'local') {
      //    const originalConsoleError = console.error;
      //    console.error = (message) => {
      //       originalConsoleError('Sentry error:', message);
      //    };
      //    console.warn = (message) => {
      //       originalConsoleError('Sentry warning:', message);
      //    };
      // }

      app.use(plugin)
         // Add Pinia to your app
         .use(pinia)
         // .use(i18nVue, {
         //     // resolve: async (lang) => {
         //     //     const langs = import.meta.glob('../lang/*.json');
         //     //     return await langs[`../lang/${lang}.json`];
         //     // },
         //     resolve: async (lang) => {
         //         // console.log(lang);
         //         // const lang = 'nl';
         //         // const langs = import.meta.glob('../../lang/*.json');
         //         return await import(`../lang/${lang}.json`);
         //     },
         // })
         // .use(i18n)
         .use(VueScrollTo, {
            container: 'body',
            easing: 'ease-in',
            lazy: true,
            force: true,
            cancelable: true,
            onStart: function () {
               // scrolling started
            },
            onDone: function () {
               // scrolling is done
            },
            onCancel: function () {
               // scrolling has been interrupted
            },
            x: false,
            y: true,
         })
         .component('Link', Link)
         .component('Head', Head)
         .component('Fa', FontAwesomeIcon)
         .component('Card', Card)
         .component('CardLink', CardLink)
         .component('Date', Date)
         .component('Layout', Layout)
         .component('VuePicture', VuePicture)
         .component('InfoModal', InfoModal)
         .component('Modal', ModalComponent)
         .component('ReviewStars', ReviewStars)
         .component('LazyHydrate', LazyHydrationWrapper)
         // .component('Counter', Counter)

         // Headless UI
         .component('Menu', Menu)
         .component('MenuButton', MenuButton)
         .component('MenuItem', MenuItem)
         .component('MenuItems', MenuItems)
         .component('Popover', Popover)
         .component('PopoverButton', PopoverButton)
         .component('PopoverPanel', PopoverPanel)

         .component('RadioGroup', RadioGroup)
         .component('RadioGroupDescription', RadioGroupDescription)
         .component('RadioGroupLabel', RadioGroupLabel)
         .component('RadioGroupOption', RadioGroupOption)

         .component('Listbox', Listbox)
         .component('ListboxLabel', ListboxLabel)
         .component('ListboxButton', ListboxButton)
         .component('ListboxOption', ListboxOption)
         .component('ListboxOptions', ListboxOptions)

         .component('Dialog', Dialog)
         .component('DialogOverlay', DialogOverlay)
         .component('DialogTitle', DialogTitle)
         .component('TransitionChild', TransitionChild)
         .component('TransitionRoot', TransitionRoot)

         // Wizard
         .component('KeyQty', KeyQty)
         .component('Validation', Validation)
         .component('Checkbox', Checkbox)
         .component('WizardIntro', WizardIntro)
         .component('Breadcrumbs', Breadcrumbs)

         // Need to override
         // .component('Nl2br', Nl2br)

         .mixin({
            methods: {
               url(value, param) {
                  if (param) {
                     return `${base_url}/${value}/${param}`
                  } else {
                     return `${base_url}/${value}`
                  }
               },
               asset(value, param) {
                  if (param) {
                     return `${file_asset_url}/${value}/${param}`
                  } else {
                     return `${file_asset_url}/${value}`
                  }
               },

               env() {
                  return env
               },

               price(value) {
                  if (value == 0) return '0,00'
                  if (!value) return ''
                  return currencyFormat(Number(value))
               },

               priceEuro(value) {
                  if (value == 0) return '0,00'
                  if (!value) return ''
                  return '€ ' + currencyFormat(Number(value))
               },
               $t(key) {
                  return key // TODO: Add translation
               },
               logError(error, page) {
                  const { logError } = useErrorLogging()
                  return logError(error, page)
               },
            },

            // Get locale and return as computed property
            computed: {
               locale() {
                  return locale
               },
            },
         })

         // Product
         .component('UploadFile', UploadFile)

      // Configure global async component timeout
      app.config.globalProperties.$asyncComponentLoadingTimeout = 15000

      // Configure loading component for async components
      app.config.globalProperties.$asyncComponentLoadingComponent = {
         template: '<div class="loading-placeholder"><div class="loading-spinner"></div></div>',
         setup() {
            return {}
         },
      }

      // Initialize the store with initial page props
      const appStore = useAppStore(pinia)
      appStore.initialize(props.initialPage.props)

      // Add property
      const cartStore = useCartStore(pinia)
      cartStore.initialize(props.initialPage.props)

      // Add property
      app.config.globalProperties.$appStore = appStore
      app.config.globalProperties.$cartStore = cartStore

      app.mount(el)

      // Initialize history state before mounting
      initializeHistoryState()

      // Make it available globally
      window.$scrollTo = VueScrollTo.scrollTo

      return app
   },
})

function currencyFormat(num) {
   return num
      .toFixed(2)
      .replace('.', ',')
      .replace(',00', ',-')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

// Add a check for null state before accessing scrollRegions
function getScrollRegions() {
   return window.history.state?.scrollRegions || []
}

// Initialize history state if it doesn't exist
function initializeHistoryState() {
   if (!window.history.state) {
      window.history.replaceState(
         {
            scrollRegions: [],
            documentScroll: { x: 0, y: 0 },
         },
         ''
      )
   }
}

// Add scroll management to router events
router.on('before', (event) => {
   const regions = getScrollRegions()
   if (regions.length > 0) {
      event.detail.visit.preserveScroll = true
   }
})
